// import 'zone.js/dist/zone';
import Vue from "vue"
import router from '../router'
import store from '../store'
import App from '../App.vue'
import appStore from '../utils/app-store'

import Antd from 'ant-design-vue'
// import 'ant-design-vue/dist/antd.less'

import VueI18n from 'vue-i18n'
import messages from '@/language'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI)

Vue.use(Antd)
Vue.use(VueI18n)

Vue.config.productionTip = false
Vue.prototype.$actions = appStore()


const language = (
  (navigator.language ? navigator.language : navigator.userLanguage) || 'zh'
).toLowerCase()

const i18n = new VueI18n({
  fallbackLocale: 'ch',
  globalInjection: true,
  locale: language.split('-')[0] || 'zh',
  messages
})

new Vue({
  el: '#main-container',
  router,
  store,
  i18n,
  template: `<a-config-provider prefixCls="${process.env.VUE_APP_FORMATS === 'campus'? 'jinmao' : (process.env.VUE_APP_FORMATS ? process.env.VUE_APP_FORMATS : 'business')}"><App /></a-config-provider>`,
  components: { App }
})
